import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  ConverterService,
  OccEndpointsService,
  OccProductSearchAdapter,
  PRODUCT_SEARCH_PAGE_NORMALIZER,
  SearchConfig,
} from '@spartacus/core'
import { defaultSearchPageSize } from '../config/custom-view-config'

const DEFAULT_SEARCH_CONFIG: SearchConfig = {
  pageSize: defaultSearchPageSize,
}

@Injectable({
  providedIn: 'root'
})
export class MbOccProductSearchAdapter extends OccProductSearchAdapter {

  constructor (protected http: HttpClient,
               protected occEndpoints: OccEndpointsService,
               protected converter: ConverterService) {
    super(http, occEndpoints, converter)
  }

  search (query: string, searchConfig: SearchConfig = DEFAULT_SEARCH_CONFIG) {
    /* New endpoint call to retrieve all products for /search router navigation*/
    if(query === undefined) {
      return this.http
        .get(this.getAllProductSearchEndpoint(':relevance::', searchConfig))
        .pipe(this.converter.pipeable(PRODUCT_SEARCH_PAGE_NORMALIZER))
    }

    return this.http
      .get(this.getSearchEndpoint(query, searchConfig))
      .pipe(this.converter.pipeable(PRODUCT_SEARCH_PAGE_NORMALIZER))
  }

  getAllProductSearchEndpoint (query: string, searchConfig: SearchConfig) {
    return this.occEndpoints.buildUrl('allProductSearch', {
      queryParams: { query, ...searchConfig },
    })
  }
}
